module.exports = __webpack_public_path__ + "static/img/icon-part2-5.eb1e1d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon-part2-5.png
// module id = dlvf
// module chunks = 1